import React from "react";
import { CheckIcon } from "lucide-react";
import { Accordion } from "./Accordion";
import { CATEGORIES } from "../lib/data";
export function ModulesSection() {
  let moduleIndex = 0;
  return <section className="px-4 py-6" data-id="element-140" data-mp="1iv1pgzzmh6ix">
      <h2 className="text-center text-2xl font-black leading-tight text-white" data-id="element-141" data-mp="1iw3238wae12r">
        Justo por eso, creamos{" "}
        <span className="text-[#8bc34a]" data-id="element-142" data-mp="1dudslxoppvgs">Profe Fútbol Resuelto</span>
      </h2>
      <p className="mt-2 text-center text-sm text-slate-200" data-id="element-143" data-mp="2bjqmamtnapov">
        8 tomos completos organizados por etapa de formación
      </p>

      <div className="mt-6 space-y-6" data-id="element-144" data-mp="26jb5tme2h22o">
        {CATEGORIES.map(cat => <div key={cat.label} data-id="element-145" data-mp="21k85gf917k11">
            <h3 className="mb-3 rounded-lg bg-[#8bc34a] px-3 py-2 text-center text-sm font-black uppercase tracking-wide text-[#0f2c4a]" data-id="element-146" data-mp="1wn88ctu5trm2">
              {cat.label}
            </h3>
            <div className="space-y-2.5" data-id="element-147" data-mp="q4jgjic7waxl">
              {cat.modules.map(mod => {
            moduleIndex += 1;
            return <Accordion key={mod.title} defaultOpen={moduleIndex === 1} header={<span className="block" data-id="element-149" data-mp="1nrz7wnmvguqy">
                        <span className="mr-1.5" data-id="element-150" data-mp="18w13ki2sok3n">{mod.emoji}</span>
                        {mod.title}
                        {mod.highlight && <span className="mt-1.5 block text-xs font-extrabold leading-snug text-[#6d9f30]" data-id="element-151" data-mp="1dxyulyhfsj75">
                            {mod.highlight}
                          </span>}
                      </span>} data-id="element-148" data-mp="1iwa3a5vzwnns">
                    <ul className="space-y-2" data-id="element-152" data-mp="q8e9pa1q3bv8">
                      {mod.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-153" data-mp="v5xnk8uidmmn">
                          <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#8bc34a]" data-id="element-154" data-mp="h6y1n8ydrlu6" />
                          <span className="text-sm text-slate-700" data-id="element-155" data-mp="l6f6q19wagyt">{item}</span>
                        </li>)}
                    </ul>
                  </Accordion>;
          })}
            </div>
          </div>)}
      </div>
    </section>;
}